import { useEffect, useState, Fragment } from "react"
import { TableContainer, Table, TableHead, TableRow, TableBody, Paper, TableCell, Collapse, IconButton, Box, Typography } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from "react-redux"
import { obtenerGrupoClaveViajeAction, obtenerFechaSalidaAction } from "../../../ducks/cambiosClaveViaje"
import { FormatoFechaIso } from "../../../utils/FormatFecha"
import FieldFechaCustom from "../FieldFechaCustom"
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import DReferencias from "../DReferencias"
export const VCambioPasajerosStyle = makeStyles((theme) => ({
    root: {
        margin: "10px 0",
    },
    content: {
        margin: "20px 0",
    },
    contentButton: {
        margin: "20px 0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    table: {
        minWidth: 650,
    },
}))
const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
})
const TGrupo = () => {
    const classes = VCambioPasajerosStyle()
    const dispatch = useDispatch()
    const { clavePaquete, listaGrupoClaveViaje } = useSelector(store => store.cambiosGrupales)
    useEffect(() => {
        dispatch(obtenerGrupoClaveViajeAction({ ClavePaquete: clavePaquete }))
        dispatch(obtenerFechaSalidaAction({ ClavePaquete: clavePaquete }))
    }, [dispatch, clavePaquete])

    const Row = (props) => {
        const { ClaveViaje, FechaSalida, Cantidad, Iterable } = props
        const [open, setOpen] = useState(false);
        const classes = useRowStyles();
        return (
            <Fragment>
                <TableRow className={classes.root} hover>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell align="center">{`${Iterable}`}</TableCell>
                    <TableCell align="center">{`${ClaveViaje}`}</TableCell>
                    <TableCell align="center">{FormatoFechaIso({ date: FechaSalida, formato: "dd MMMM yyyy" })}</TableCell>
                    <TableCell align="center">{Cantidad}</TableCell>
                    <TableCell align="center">
                        <DReferencias ClaveViaje={ClaveViaje} />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box margin={1}>
                                <Typography variant="h6" gutterBottom component="div">
                                    Acción
                                </Typography>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                        <FieldFechaCustom ClaveViaje={ClaveViaje} />
                                    </div>
                                </div>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </Fragment>
        )
    }
    return (
        <div className={classes.root}>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ minWidth: 10 }}></TableCell>
                            <TableCell style={{ minWidth: 50 }} align="center">#</TableCell>
                            <TableCell style={{ minWidth: 50 }} align="center">ClaveViaje</TableCell>
                            <TableCell style={{ minWidth: 50 }} align="center">Fecha salida</TableCell>
                            <TableCell style={{ minWidth: 50 }} align="center">Cantidad referencias</TableCell>
                            <TableCell style={{ minWidth: 50 }} align="center">Acción</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            listaGrupoClaveViaje.map((item, index) => (
                                <Row
                                    key={item.ClaveViaje}
                                    ClaveViaje={item.ClaveViaje}
                                    FechaSalida={item.FechaSalida}
                                    Cantidad={item.Cantidad}
                                    Iterable={index + 1}
                                />
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
export default TGrupo